<h4 mat-dialog-title><span><mat-icon class="dialog-icon">{{data.icon}}</mat-icon>{{data.title}}</span></h4>
<div mat-dialog-content>
    <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button *ngFor="let item of data.buttons" mat-button (click)="onButtonClick(item)">{{item}}</button>
</div>